"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTv = function IconTv(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M6.051 9H41.95v25H6.05zm6.058 27H4V7h40v29h-8.11L37 40h-2.108l-1.11-4H14.218l-1.11 4H11zm-.629-25 .707.707-3.48 3.48L8 14.48zm3.037 1.297-.707-.707-5.22 5.22.707.707zm-.116 1.622.706.709-3.49 3.48-.706-.709zM41 33H7v-1h34z",
    clipRule: "evenodd"
  })));
};

export { IconTv, IconTv as default };
